module.exports = __webpack_public_path__ + "media/images/level_introduction4_sp-87750a664d9bd9f3fee349124214de07.png";